import {
  Button,
} from "@material-tailwind/react";
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { IoAdd } from "react-icons/io5";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from "react";
import { getRole } from "../redux/slices/getRoleSlice";
import { fetchUsers } from "../redux/slices/userSlice";
import ButtonLoader from "../components/ButtonLoader";
import { AddUser } from "../services/manageUserServices";
import { PiArrowsClockwiseFill } from "react-icons/pi";

const generatePassword = (length = 12) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let password = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    password += chars[randomIndex];
  }
  return password;
};

export function AddNewUser() {
  const dispatch = useDispatch()
  const [isOpen, setIsopen] = useState(false)
  const [loading, setLoading] = useState(false)

  const RolesLevel = useSelector((state) => state.auth.user);
  const RoleLevel = RolesLevel?.data?.profile?.roleName
  const roles = useSelector((state) => state.roles?.roles?.data);

useEffect(() =>{
  dispatch(getRole())
  dispatch(fetchUsers())
}, [dispatch])

  const formik = useFormik({
      initialValues: {
          roleName: "",
          userName: "",
          emailAddress: "",
          password: "",
          phoneNumber: ""
      },
      validationSchema: Yup.object({
          userName: Yup.string().required('UserName is required'),
          roleName: Yup.string().required('RoleName is required')
                .oneOf(["Admin", "Staff"], 'Invalid option'),
          emailAddress: Yup.string().email('Invalid email address').required('Email is required'),
          password: Yup.string().min(6, 'Password must be at least 6 characters').required('password is required'),
      }),
      onSubmit: async (values) => {
        if (RoleLevel !== "SuperAdmin") {
          toast.error("You must be SuperAdmin in to create a user.");
          return;
        }
        if(RoleLevel === "SuperAdmin"){
          setLoading(true);
          try {
            const res = await AddUser(values)
          if (res.statusCode === 200) {
            dispatch(fetchUsers())
            toast.success(res.data);
            formik.resetForm()
            setLoading(false)
            setIsopen(false)
          } else if (res.statusCode === 205) {
            toast.error(res.message);
            setLoading(false)
          } else if(res?.statusCode === 404){
            toast.error(res.message)
            setLoading(false)
          } else if(res?.statusCode === 404){
            toast.error(res.message)
            setLoading(false)
          } else {
            toast.error(res.message)
            setLoading(false)
          }
          } catch (error) {
            toast.error('An error occurred during user creation');
          }
        }
      }
    });
  return (
    <div>
      <Button 
        onClick={() => setIsopen(true)}
        className="bg-primaryRed hover:bg-opacity-50 outline-0 hover:bg-primaryRed focus:outline-0 hover:outline-0 text-white px-4 py-2 flex items-center rounded-md justify- border-0">
        <IoAdd className="text-xl mr-3 font-bold text-white"/> 
        <p className="text-sm lg:text-md">Add New User</p>
      </Button>
      <Drawer anchor="right" open={isOpen} onClose={() => setIsopen(false)} size="md"
         slotProps={{
          root: {
            className: `
              backdrop-blur-[1px] 
              bg-orange/20 
              rounded-tl-2xl 
            `,
          },
        }}  
      >
          <ModalClose />
            <div className="flex items-center justify-between gap-4 px-5 pt-10">
              <p className="capitalize text-[24px] font-bold text-primaryRed">add new user</p>
            </div>

            <p className="my-4 text-xs md:text-sm px-5 text-[10] text-[#0A0A0A]/80">
            Get a complete view of customer feedback to understand experiences better and take actions that enhance service quality.
            </p>

            <form onSubmit={formik.handleSubmit} className="mt-3 text-sm space-y-4 p-5">
              <div>
                <label htmlFor="userName">Username</label>
                <input 
                    id="userName"
                    name="userName"
                    value={formik.values.userName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="username"
                    className={`mt-2 border-2 border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 focus:outline-0 `}
                  />
                  {formik.touched.userName && formik.errors.userName ? (
                          <div className='text-sm mt-1 text-red-500'>{formik.errors.userName}</div>
                    ) : null 
                  }
              </div>
              <div>
                <label htmlFor="roleName">Role Name</label>
                <div className="my-2">
                  <select
                    id="roleName"
                    name="roleName"
                    value={formik.values.roleName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="border-2 border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 focus:outline-0"
                  >
                    <option value="" disabled>Select a Role </option>
                    {roles && roles.length > 0 ? (
                        roles.map(role => <option key={role.roleId}>{role.name}</option>)
                      ) : (
                        <span>No roles available</span>
                      )}
                    {formik.touched.roleName && formik.errors.roleName ? (
                      <span className='text-sm mt-1 text-red-500'>{formik.errors.roleName}</span>
                    ) : null };
                  </select>
                </div>
              </div>
              <div>
                <label htmlFor="emailAddress">E-mail</label>
                <input 
                  id="emailAddress"
                  name="emailAddress"
                  value={formik.values.emailAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Email Address"
                  className={`mt-2 border-2 border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 placeholder:text-gray-400 outline-none ring-0 focus:outline-0 `}
                />
                {formik.touched.emailAddress && formik.errors.emailAddress ? (
                    <div className='text-sm mt-1 text-red-500'>{formik.errors.emailAddress}</div>
                  ) : null 
                }
              </div>
              <div>
                <label htmlFor="phoneNumber">Phone Number</label>
                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                    placeholder="Phone Number" 
                    className="mt-2 border-2 border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 placeholder:text-gray-400 outline-none ring-0 focus:outline-0" 
                />
                {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                  <div className='text-sm mt-1 text-red-500'>{formik.errors.phoneNumber}</div>
                  ) : null
                }
              </div>
              <div className="relative">
                <label htmlFor="password">Generate Temporary Password</label>
                <input
                  id="password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Generate temporary password"
                  className="mt-2 border-2 border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 placeholder:text-gray-400 outline-none ring-0 focus:outline-0"
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className='text-sm mt-1 text-red-500'>{formik.errors.password}</div>
                ) : null }
                <PiArrowsClockwiseFill
                  onClick={() => formik.setFieldValue("password", generatePassword(12))}
                  className="absolute right-4 bottom-8 text-[#0A0A0A]/60"
                 />
                <p className="text-xs text-gray-500 mt-1">Minimium of 6 alphabets</p>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="bg-[#FF0000] hover:bg-primaryRed/80 text-white py-2 w-full rounded-md text-md mt-10"
              >
                {loading ? <ButtonLoader />
                  : <span> send activation email</span>
                  } 
              </button>
            </form>
      </Drawer>
    </div>
  );
}
                        